module.exports = __webpack_public_path__ + "static/media/_corsica.11859084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_corsica.svg
// module id = 2311
// module chunks = 7